
import * as actions from 'actions';
import categorySelectionMaker from 'reducersMakers/categorySelectionMaker';

export default categorySelectionMaker({
  selectType: actions.CATEGORY_SELECT,
  idKey: 'categoryId'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/categories/categorySelection/forumThreads/reducer.js
 **/